import { useNavigate } from 'react-router-dom';
import OrderConfirmation from '../pages/OrderConfirmation';

const OrderConfirmationWrapper = () => {
  const navigate = useNavigate();
  return <OrderConfirmation navigate={navigate} />;
};

export default OrderConfirmationWrapper;
